import type { LoyaltyClubPage, LoyaltyPage, LoyaltyPassaportPage } from './useLoyalty.types'

export async function fetchLoyaltyPage(language: string): Promise<LoyaltyPage> {
  try {
    const params: Record<string, string> = {
      language
    }

    return await $fetch<LoyaltyPage>('/api/directus/loyalty', {
      params
    })
  } catch (error) {
    console.error('Erro ao buscar hotéis por categoria:', error)
    return {} as LoyaltyPage
  }
}

export async function fetchLoyaltyClubPage(language: string): Promise<LoyaltyClubPage> {
  try {
    const params: Record<string, string> = {
      language
    }

    return await $fetch<LoyaltyClubPage>('/api/directus/loyalty-club', {
      params
    })
  } catch (error) {
    console.error('Erro ao buscar hotéis por categoria:', error)
    return {} as LoyaltyClubPage
  }
}

export async function fetchLoyaltyPassaportPage(id: string, language: string): Promise<LoyaltyPassaportPage> {
  try {
    const params: Record<string, string> = {
      language
    }

    return await $fetch<LoyaltyPassaportPage>('/api/directus/loyalty-passaports?id=' + id, {
      params
    })
  } catch (error) {
    console.error('Erro ao buscar hotéis por categoria:', error)
    return {} as LoyaltyPassaportPage
  }
}
